import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// styles
import styles from './PdpRespHeroCarousel.scss';

// helpers
import get from 'lodash.get';
import { getPrimarySkuPhoto } from '../helpers/getSortedPhotos';

export function PdpRespHeroCarouselPrintComponent(props) {
    const { selectedSkuId, item } = props;
    const photo = item.isMultiSku
        ? getPrimarySkuPhoto(selectedSkuId, item.sortedPhotos)
        : get(item, 'photos[0]');

    return (
        <div className={styles.printCarousel}>
            <img className={styles.printImage} src={get(photo, 'largePath')} />
        </div>
    );
}

PdpRespHeroCarouselPrintComponent.propTypes = {
    item: PropTypes.object.isRequired,
};

export const PdpRespHeroCarouselPrint = createFragmentContainer(PdpRespHeroCarouselPrintComponent, {
    item: graphql`
        fragment PdpRespHeroCarouselPrint_item on Item {
            isMultiSku
            photos {
                largePath
            }
            sortedPhotos {
                largePath
                sortOrder
                imageSkuXrefs {
                    skuId
                }
            }
        }
    `,
});
